import React from "react";
import { inr, num, pct } from "../lib/api";
import { ArrowUpRight, ArrowDownRight, Wallet, Activity, CheckCircle2, XCircle } from "lucide-react";

export default function StatsCards({ stats, totalLivePL }) {
  if (!stats) return null;
  const realized = stats.realized_pl ?? 0;
  const live = totalLivePL ?? 0;
  const totalPL = realized + live;
  const winRate = stats.win_rate ?? 0;

  const cards = [
    {
      label: "Net P&L",
      value: inr(totalPL),
      sub: `Realized ${inr(realized)} · Live ${inr(live)}`,
      tone: totalPL >= 0 ? "profit" : "loss",
      Icon: totalPL >= 0 ? ArrowUpRight : ArrowDownRight,
      testid: "stats-total-pl",
    },
    {
      label: "Open Positions",
      value: num(stats.open_count, 0),
      sub: `Invested ${inr(stats.invested_open)}`,
      tone: "neutral",
      Icon: Activity,
      testid: "stats-open",
    },
    {
      label: "Closed Trades",
      value: num(stats.closed_count, 0),
      sub: `Wins ${stats.wins} · Losses ${stats.losses}`,
      tone: "neutral",
      Icon: Wallet,
      testid: "stats-closed",
    },
    {
      label: "Win Rate",
      value: pct(winRate, 1),
      sub: stats.wins + stats.losses > 0 ? `${stats.wins} winners` : "No closed trades yet",
      tone: winRate >= 50 ? "profit" : winRate > 0 ? "warning" : "neutral",
      Icon: winRate >= 50 ? CheckCircle2 : XCircle,
      testid: "stats-winrate",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#27272A] border border-[#27272A]">
      {cards.map((c) => {
        const toneCls =
          c.tone === "profit" ? "text-[#00C805]"
          : c.tone === "loss" ? "text-[#FF3B30]"
          : c.tone === "warning" ? "text-[#FFB800]"
          : "text-white";
        return (
          <div
            key={c.label}
            data-testid={c.testid}
            className="bg-[#121318] p-5 hover:bg-[#1A1B23] transition-colors duration-150"
          >
            <div className="flex items-center justify-between">
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#71717A] font-semibold">{c.label}</div>
              <c.Icon className={`h-4 w-4 ${toneCls}`} />
            </div>
            <div className={`mt-3 text-3xl font-semibold num ${toneCls}`}>{c.value}</div>
            <div className="mt-1 text-xs text-[#A1A1AA] num">{c.sub}</div>
          </div>
        );
      })}
    </div>
  );
}
